import React from "react";
import { createTheme, ThemeProvider, Container } from "@mui/material";
import "./AboutTemplate.scss";
import Grid from "@mui/material/Unstable_Grid2";


const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1620,
        },
    },
});

const AboutTemplate: React.FC = () => {

    return (
        <>
            <section className="about-section">
                <ThemeProvider theme={theme}>
                    <Container maxWidth="xl">
                        <Grid container direction="row" alignItems="flex-end">
                            <Grid lg={6} md={12} mdOffset={6}>
                                <div className="title-main">
                                    <small className="blue">API OVERVIEW</small>
                                    <h2 className="title-xl">About AaNeel Connect API</h2>
                                </div>
                                <div className="about-content">
                                    <div>
                                        <h3 className="title-md">Overview of the Product</h3>
                                        <p>
                                            Application Programming Interfaces (APIs) to improve the
                                            electronic exchange of healthcare data—sharing
                                            information with patients or exchanging information
                                            between a payer and provider or between two payers.
                                        </p>
                                    </div>
                                    <div>
                                        <h3 className="title-md">Product Description</h3>
                                        <Grid container spacing={4}>
                                            <Grid xs={12}>
                                                <p>
                                                    In compliance with the CMS Interoperability and
                                                    Patient Access Final Rule (CMS-9115-F), payers are
                                                    mandated to provide access to provider information.
                                                    The APIs outlined here are necessary for directly
                                                    retrieving provider information.
                                                </p>
                                            </Grid>
                                        </Grid>
                                        <p>
                                            Additional information about this API can be found in
                                            the Capability Statement API and the Swagger
                                            documentation.
                                        </p>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Container>
                </ThemeProvider>
            </section>
        </>
    );
};

export default AboutTemplate;
